import { useTranslations } from '@vocab/react';

import { PageViewTracker } from 'src/app/dataAnalytics/components/PageViewTracker';
import { IntercomConfiguration } from 'src/app/intercom';
import { SeoTitle } from 'src/app/views/shared/SeoTitle';

import type { EmployerSiteName } from '../../../../types/app';
import { usePageId } from '../../hooks/usePageId';
import translations from '../.vocab';

interface Props {
  site: EmployerSiteName;
  children: React.ReactNode;
}

const RootContainer = ({ site, children }: Props) => {
  const { t } = useTranslations(translations);
  usePageId();

  return (
    <>
      <SeoTitle title={t('root-container-seo-title')} />
      <PageViewTracker />
      <IntercomConfiguration site={site} />
      {children}
    </>
  );
};

export default RootContainer;
